import "@babel/polyfill";

import $ from "jquery";
import Vue from "vue/dist/vue.common.js";

Vue.config.productionTip = false;

import "./Store";

import "./lib/svg";
import "./lib/objectFit";
import "./lib/hello";
import "./lib/focus";
// import "./lib/scrollbar";
import "./lib/lazy";
import "./lib/scroll";
import "./lib/touch";

import "../components/page/page";
import "../components/header/header";
import "../components/modal/modal";
import "../components/search-header/search-header";
import "../components/cart-header/cart-header";
import "../components/cart-footer/cart-footer";
import "../components/counter/counter";
import "../components/minicart/minicart";
import "../components/switches/switches";
import "../components/filter/filter";
import "../components/roll/roll";
import "../components/tabs/tabs";
import "../components/slider/slider";
import "../components/input/select";
import "../components/input/range";
import "../components/info/info";
import "../components/history-item/history-item";
import "../components/product/product";
import "../components/cart-list/cart-list";
import "../components/cards/cards";
import "../components/product-order/product-order";
import "../components/products-list/products-list";
import "../components/selection-form/selection-form";
import "../components/map/map";
import "../components/products/products";
import "../components/view/view";
import "../components/sort/sort";
import "../components/manufacturers/manufacturers";
import "../components/tooltip/tooltip";
import "../components/image/image";
import "../components/cerf/cerf";
import "../components/reviews/reviews";
import "../components/menu/menu";
import "../components/nav/nav";
import "../components/city-select/city-select";
import "../components/content/content";
import "../components/sidebar/sidebar";
import "../components/image-upload/image-upload";
import "../components/selection-form/selection-form";
import "../components/form-modal/form-modal";
import "../components/form/order-form";
import "../components/cookies/cookies";

/* Add jQuery to global scope */
window.jQuery = window.$ = $;
